import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'

export default (items) => {
  const computedValues = items.map(i => {
    i.itemId = i.itemId

    // ----- ITEM INFO FIELDS -----
    const quantity = (i.itemInfo && i.itemInfo.quantity) || 0
    const factor = (i.itemInfo && i.itemInfo.factor) || 0

    // QUOTE MAP
    const waitingResponseQuotation = i.quotations && i.quotations.filter(q => !q.receiveDate)
    const avaliableQuotation = i.quotations && i.quotations.filter(q => !!q.receiveDate && !q.notQuote)
    const rejectedQuotation = i.quotations && i.quotations.filter(q => q.notQuote)
    const noquoteQuotation = rejectedQuotation.length > 0 && rejectedQuotation.length === i.quotations.length
    const noSendedQuotation = !i.quotations || (i.quotations && i.quotations.length === 0)

    i.quotationMap = {
      waitingResponseQuotation: waitingResponseQuotation && waitingResponseQuotation.length,
      avaliableQuotation: avaliableQuotation && avaliableQuotation.length,
      rejectedQuotation: rejectedQuotation && rejectedQuotation.length,
      noquoteQuotation,
      noSendedQuotation
    }

    // ----- ASSOCIATED -----
    const isAssociated = !!(i.associated && i.associated.hasOwnProperty('codProd'))
    i.associated.isAssociated = isAssociated
    i.associated.price = isAssociated ? i.associated.price * factor : 0
    i.associated.priceTotal = isAssociated ? i.associated.price * quantity : 0
    i.associated.cmedPrice = isAssociated && i.associated.cmedPrice ? i.associated.cmedPrice * factor : 0
    i.associated.cmedPriceTotal = isAssociated && i.associated.cmedPrice ? i.associated.cmedPrice * quantity : 0

    // ----- QUOTED -----
    const isQuoted = !!(i.quoted && i.quoted.itemId && !!i.quoted.itemId)
    i.quoted.isQuoted = isQuoted
    const quotedPrice = isQuoted ? i.quoted.price : 0
    i.quoted.priceTotal = isQuoted ? quotedPrice * quantity : false

    // ----- QUOTATIONS -----
    const quotations = i.quotations.map(q => {
      const cmedPrice = q.cmedPrice * factor
      return {
        ...q,
        cmedPrice,
        cmedTotalPrice: cmedPrice * quantity,
        priceTotal: q.price * quantity
      }
    })
    i.quotations = quotations

    // ----- CMED -----
    const haveMaxPrice = !!(i.quoted && i.quoted.cmedPrice)
    i.quoted.haveMaxPrice = haveMaxPrice
    const maxPrice = haveMaxPrice ? i.quoted.cmedPrice * factor : 0
    i.quoted.cmedPrice = maxPrice
    i.quoted.cmedTotalPrice = haveMaxPrice ? maxPrice * quantity : false
    i.quoted.cmedPerc = haveMaxPrice ? (((maxPrice * 100) / i.quoted.price) - 100).toFixed() : false

    // ----- ESTIMATED -----
    const finalPrice = isQuoted ? quotedPrice : isAssociated ? i.associated.price : 0
    const haveEstimated = !!(i.itemInfo && i.itemInfo.estimatedPrice)
    i.itemInfo.haveEstimated = haveEstimated
    const estimatedPrice = haveEstimated ? i.itemInfo.estimatedPrice : 0
    i.itemInfo.estimatedTotalPrice = haveEstimated ? estimatedPrice * quantity : false
    i.itemInfo.estimatedPerc = haveEstimated ? (((estimatedPrice * 100) / finalPrice) - 100).toFixed() : false

    // Check Higher comparision
    const lowerValue = DefineLowestMaxPrice(i.quoted.cmedPrice, i.itemInfo.estimatedPrice)

    // ----- PROPOSAL -----
    const haveProposal = !!(i.quoted && i.quoted.proposalPrice)
    i.quoted.haveProposal = haveProposal
    const proposalPrice = haveProposal ? i.quoted.proposalPrice : 0
    i.quoted.proposalTotalPrice = haveProposal ? proposalPrice * quantity : false
    i.quoted.proposalPerc = haveProposal ? (((proposalPrice * 100) / i.quoted.price) - 100).toFixed() : false
    i.quoted.proposalIsHigherThanMaxprice = lowerValue < proposalPrice

    // ----- MINIMUM -----
    const haveMinimum = !!(i.quoted && i.quoted.minimumPrice)
    i.quoted.haveMinimum = haveMinimum
    const minimumPrice = haveMinimum ? i.quoted.minimumPrice : 0
    i.quoted.minimumTotalPrice = haveMinimum ? minimumPrice * quantity : false
    i.quoted.minimumPerc = haveMinimum ? (((minimumPrice * 100) / i.quoted.price) - 100).toFixed() : false
    i.quoted.minimumIsHigherThanMaxprice = lowerValue < minimumPrice
    // ----- DYNAMIC LINKS -----
    const haveDynamicColumns = i.dynamicColumns && i.dynamicColumns.length > 0
    i.haveDynamicColumns = haveDynamicColumns
    // i.dynamicColumns = haveDynamicColumn ? i.dynamicColumns : []
    // const dybamicValue = haveDynamicColumn ? i.dynamicColumns[] : 0

    // // ----- PROPOSAL -----
    // i.quoted.proposalTotalPrice = haveProposal ? proposalPrice * quantity : false
    // i.quoted.proposalPerc = haveProposal ? (((proposalPrice * 100) / i.quoted.price) - 100).toFixed() : false
    // i.quoted.proposalIsHigherThanMaxprice = lowerValue < proposalPrice

    return i
  })

  return computedValues
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/list-all-items/FormatListItem.js